import LayoutManager from'./LayoutManager'
import ResponsiveProperty from '../data/ResponsiveProperty'

declare global {
    interface JQuery {
        masonry(method: string, ...params: any): JQuery;
    }
}

interface MasonryLayoutManagerOptions {
    horizontalOrder: boolean,
    columns: ResponsiveProperty,
    columnGap: number,
    rowGap: number
}

class MasonryLayoutManager extends LayoutManager {

    views: JQuery[] = []

    options: MasonryLayoutManagerOptions
    masonryOptions = {}


    constructor(itemGrid: JQuery) {
        super(itemGrid)

        this.options = itemGrid.data('options')

        const masonryOptions = {
            itemSelector: '.grid-item',
            gutter: this.options.columnGap,
            horizontalOrder: this.options.horizontalOrder,
            stagger: 30
        }

        itemGrid.masonry(masonryOptions)
    }

    getCustomStyles(wrapper: string): string {
        const colsM = this.options.columns.mobile.value
        const colsT = this.options.columns.tablet.value
        const colsD = this.options.columns.desktop.value
        const breakT = this.options.columns.tablet.breakpoint
        const breakD = this.options.columns.desktop.breakpoint
        const colGap = this.options.columnGap
        return `
        ${wrapper} .dynamic-post-grid.masonry > .grid-item {
            width: calc(${100 / colsM}% - ${(colsM - 1) / colsM * colGap}px);
        }
        @media (min-width: ${breakT}px) {
        ${wrapper} .dynamic-post-grid.masonry > .grid-item {
            width: calc(${100 / colsT}% - ${(colsT - 1) / colsT * colGap}px);
        }
        }
        @media (min-width: ${breakD}px) {
        ${wrapper} .dynamic-post-grid.masonry > .grid-item {
            width: calc(${100 / colsD}% - ${(colsD - 1) / colsD * colGap}px);
        }
        }
        `
    }

    onPreUpdate() {
        this.views = []
    }

    addItem(itemView: JQuery) {
        
    }

    layoutItem(itemView: JQuery, position: number) {
        this.views[position] = itemView
    }

    removeItem(itemView: JQuery) {
        itemView.remove()
    }

    onPostUpdate() {
        for (let i = 0; i < this.views.length; i++) {
            const view = this.views[i]
            const index = this.itemGrid.children().index(view)
            if (index === i) continue
            if (view.parent().length) view.remove()
            if (i === 0) {
                this.itemGrid.prepend(view)
            } else {
                this.itemGrid.find(`.grid-item:nth-child(${i})`).after(view)
            }
        }
        this.itemGrid.masonry('reloadItems')
        this.itemGrid.masonry()
    }
}

export default MasonryLayoutManager